<template>
	<div>
		<el-form :inline="true" >
			<el-form-item>
				<el-input
						v-model="searchForm.name"
						placeholder="名称"
						clearable
				>
				</el-input>
			</el-form-item>

			<el-form-item>
				<el-button @click="getGroupList">搜索</el-button>
			</el-form-item>

			<el-form-item>
				<el-button type="primary" @click="dialogVisible = true">新增</el-button>
			</el-form-item>
			<el-form-item>
				<el-popconfirm title="确定批量删除吗？" @confirm="delHandle(null)">
					<el-button type="danger" slot="reference" :disabled="delBtlStatu">批量删除</el-button>
				</el-popconfirm>
			</el-form-item>
		</el-form>

		<el-table
				ref="multipleTable"
				:data="tableData"
				tooltip-effect="dark"
				style="width: 100%;margin-top: -10px;"
				:height="tableHeight"
				:row-style="{height: '0px'}"
				:cell-style="{padding: '2px'}"
				:header-cell-style="{background: '#E6F2FE', height:'8px',padding:'8px'}"
				border
				stripe
				@selection-change="handleSelectionChange">

			<el-table-column
					type="selection"
					width="55">
			</el-table-column>

			<el-table-column
					prop="groupName"
					label="组团名称"
					show-overflow-tooltip>
			</el-table-column>
			
			<el-table-column
					prop="remark"
					label="描述"
					show-overflow-tooltip>
			</el-table-column>

			<el-table-column
					prop="statusFlag"
					label="状态">
				<template slot-scope="scope">
					<el-tag size="small" v-if="scope.row.statusFlag === 1" type="success">正常</el-tag>
					<el-tag size="small" v-else-if="scope.row.statusFlag === 0" type="danger">禁用</el-tag>
				</template>

			</el-table-column>
			<el-table-column
					prop="icon"
					label="操作">

				<template slot-scope="scope">
					<el-button type="text" @click="editHandle(scope.row.id)">编辑</el-button>
					<el-divider direction="vertical"></el-divider>

					<template>
						<el-popconfirm title="确定删除该组团吗？" @confirm="delHandle(scope.row.id)">
							<el-button type="text" slot="reference">删除</el-button>
						</el-popconfirm>
					</template>

					<el-divider direction="vertical"></el-divider>
					<el-button type="text" @click="permHandle(scope.row.id)">设置位置</el-button>

					<el-divider direction="vertical"></el-divider>
					<el-button type="text" @click="deptHandle(scope.row.id)">设置部门</el-button>

				</template>
			</el-table-column>

		</el-table>


		<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				layout="total, sizes, prev, pager, next, jumper"
				:page-sizes="[10, 20, 50, 100]"
				:current-page="current"
				:page-size="size"
				:total="total">
		</el-pagination>


		<!--新增对话框-->
		<el-dialog
				title="提示"
				:visible.sync="dialogVisible"
				width="600px"
				:before-close="handleClose"
				:close-on-click-modal="false">

			<el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="100px" class="demo-editForm">

				<el-form-item label="组团名称" prop="groupName" label-width="100px">
					<el-input v-model="editForm.groupName" autocomplete="off"></el-input>
				</el-form-item>

				<el-form-item label="描述" prop="remark" label-width="100px">
					<el-input v-model="editForm.remark" autocomplete="off"></el-input>
				</el-form-item>


				<el-form-item label="状态" prop="statusFlag" label-width="100px">
					<el-radio-group v-model="editForm.statusFlag">
						<el-radio :label=0>禁用</el-radio>
						<el-radio :label=1>正常</el-radio>
					</el-radio-group>
				</el-form-item>

			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="resetForm('editForm')">取 消</el-button>
				<el-button type="primary" @click="submitForm('editForm')">确 定</el-button>
			</div>
		</el-dialog>

		<el-dialog
				title="设置位置"
				:visible.sync="permDialogVisible"
				width="600px"
				height="200px">

			<el-form :model="permForm" >

				<el-tree
					:data="permTreeData"
					:style="{height: '370px',overflow:'auto'}"
					show-checkbox
					ref="permTree"
					node-key="id"
					default-expand-all
					:props="defaultProps">
				</el-tree>

			</el-form>

			<span slot="footer" class="dialog-footer">
			    <el-button @click="permDialogVisible = false">取 消</el-button>
			    <el-button type="primary" @click="submitPermFormHandle('permForm')">确 定</el-button>
			</span>

		</el-dialog>

		<el-dialog
				title="设置部门"
				:visible.sync="deptDialogVisible"
				width="600px"
				height="200px">

			<el-form :model="deptForm" >

				<el-tree
					:data="deptTreeData"
					:style="{height: '370px',overflow:'auto'}"
					show-checkbox
					ref="deptTree"
					node-key="id"
					default-expand-all
					:props="defaultDeptProps">
				</el-tree>

			</el-form>

			<span slot="footer" class="dialog-footer">
			    <el-button @click="deptDialogVisible = false">取 消</el-button>
			    <el-button type="primary" @click="submitDeptFormHandle('permForm')">确 定</el-button>
			</span>

		</el-dialog>

	</div>
</template>

<script>
	export default {
		name: "GroupLocation",
		data() {
			return {
				searchForm: {},
				delBtlStatu: true,

				total: 0,
				size: 10,
				current: 1,

				dialogVisible: false,
				editForm: {

				},

				tableData: [],

				editFormRules: {
					groupName: [
						{required: true, message: '请输入组团名称', trigger: 'blur'}
					],
					statusFlag: [
						{required: true, message: '请选择状态', trigger: 'blur'}
					]
				},

				multipleSelection: [],

				permDialogVisible: false,
				permForm: {},
				defaultProps: {
					children: 'children',
					label: 'locationName'
				},
				permTreeData: [],

				deptDialogVisible: false,
				deptForm: {},
				defaultDeptProps: {
					children: 'children',
					label: 'deptName'
				},
				deptTreeData: []
			}
		},
		computed: {
			tableHeight: function() {
				return screen.height > 900 ? 650: 550
			}
		},
		created() {
			// 取组团列表
			this.getGroupList()

			// 取位置数据
			this.getLocationTree();

			// 取部门数据
			this.getDeptTree();
		},
		methods: {
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			handleSelectionChange(val) {
				console.log("勾选")
				console.log(val)
				this.multipleSelection = val;

				this.delBtlStatu = val.length == 0
			},

			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.size = val
				this.getGroupList()
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.current = val
				this.getGroupList()
			},

			resetForm(formName) {
				this.$refs[formName].resetFields();
				this.dialogVisible = false
				this.editForm = {}
			},
			handleClose() {
				this.resetForm('editForm')
			},

			getGroupList() {
				this.$axios.get("/pin/group/list", {
					params: {
						name: this.searchForm.name,
						current: this.current,
						size: this.size
					}
				}).then(res => {
					this.tableData = res.data.data.records
					this.size = res.data.data.size
					this.current = res.data.data.current
					this.total = res.data.data.total
				})
			},

			getLocationTree() {
				this.$axios.get("/base/location/list").then(res => {
					this.permTreeData = res.data.data
				})
			},

			getDeptTree() {
				this.$axios.get("/base/dept/list").then(res => {
					this.deptTreeData = res.data.data
				})
			},

			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$axios.post('/pin/group/' + (this.editForm.id?'update' : 'save'), this.editForm)
							.then(res => {

								this.$message({
									showClose: true,
									message: '操作成功',
									type: 'success',
									onClose:() => {
										this.getGroupList()
									}
								});

								this.dialogVisible = false
								this.resetForm(formName)
							})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			editHandle(id) {
				this.$axios.get('/pin/group/info/' + id).then(res => {
					this.editForm = res.data.data

					this.dialogVisible = true
				})
			},
			delHandle(id) {

				var ids = []

				if (id) {
					ids.push(id)
				} else {
					this.multipleSelection.forEach(row => {
						ids.push(row.id)
					})
				}

				console.log(ids)

				this.$axios.post("/pin/group/delete", ids).then(res => {
					this.$message({
						showClose: true,
						message: '操作成功',
						type: 'success',
						onClose:() => {
							this.getGroupList()
						}
					});
				})
			},
			permHandle(id) {
				this.permDialogVisible = true

				this.$axios.get("/pin/group/info/" + id).then(res => {

					this.$refs.permTree.setCheckedKeys(res.data.data.locationIds)
					this.permForm = res.data.data
				})
			},
			
			deptHandle(id) {
				this.deptDialogVisible = true

				this.$axios.get("/pin/group/info/" + id).then(res => {

					this.$refs.deptTree.setCheckedKeys(res.data.data.deptIds)
					this.deptForm = res.data.data
				})
			},

			submitPermFormHandle(formName) {
				var locationIds = this.$refs.permTree.getCheckedKeys()

				console.log(locationIds)

				this.$axios.post('/pin/group/location/' + this.permForm.id, locationIds).then(res => {
					this.$message({
						showClose: true,
						message: '操作成功',
						type: 'success',
						onClose:() => {
							this.getGroupList()
						}
					});
					this.permDialogVisible = false
					this.resetForm(formName)
				})
			},

			submitDeptFormHandle(formName) {
				var deptIds = this.$refs.deptTree.getCheckedKeys()

				console.log(deptIds)

				this.$axios.post('/pin/group/dept/' + this.deptForm.id, deptIds).then(res => {
					this.$message({
						showClose: true,
						message: '保存成功',
						type: 'success',
						onClose:() => {
							this.getGroupList()
						}
					});
					this.deptDialogVisible = false
					this.resetForm(formName)
				})
			}
		}
	}
</script>

<style scoped>

	.el-pagination {
		float: right;
		margin-top: 22px;
	}
</style>